/* @flow */
import * as React from 'react'
import windowView from 'shared/view/window'

const ProductItem = ({
    product,
    active,
    onClick,
    className,
    useOneTimeOfferLabel,
}: {
    active: boolean,
    onClick: Function,
    product: Object,
    className: string,
    useOneTimeOfferLabel?: boolean,
}) => {
    const testClass = className

    return (
        <div className="plan">
            {product.timePeriod === 12 ? <div className="most__popular">Most popular</div> : null}
            <div
                onClick={onClick}
                className={`${testClass} productSelection__item ${active ? 'preselected__plan' : ''}`}
            >
                {product.savingsPercentage ? (
                    <div className="paywall_productSelection__chip">
                        <span>{`Save ${product.savingsPercentage}%`}</span>
                    </div>
                ) : (
                    <div className="paywall_chip__placeholder">
                        <span>&nbsp;</span>
                    </div>
                )}

                <div className="text__block">
                    <div>
                        {useOneTimeOfferLabel
                            ? `${product.price} for ${product.label}`
                            : `${product.timePeriod} ${product.timePeriod === 1 ? 'month' : 'months'}`}
                    </div>
                    {useOneTimeOfferLabel ? null : (
                        <>
                            <div className="mt_3 fw-600">{product.price}</div>
                            <div className="fs_14  mt_3">per month</div>
                        </>
                    )}
                    <ProductItemRadio active={active} />
                </div>
            </div>
        </div>
    )
}

const ProductItemRadio = ({ active }: { active: boolean }) => {
    const iconClass = active ? null : 'is-hidden'

    return (
        <div className="paywall-productSelection__radio" role="radio" aria-checked={active}>
            <div className={iconClass} aria-hidden="true">
                <i className="icon icon-tick-green planCheck" />
            </div>
        </div>
    )
}

type Props = {
    fieldName?: string,
    productList: Object[],
    selectedProduct?: string,
    useOneTimeOfferLabel?: boolean,
}

type State = {
    fieldName?: string,
    selectedProduct?: string,
    useOneTimeOfferLabel?: boolean,
}

class ProductTable extends React.PureComponent<Props, State> {
    constructor(props: Object) {
        super(props)
        this.state = {
            selectedProduct: this.props.selectedProduct
                ? this.props.selectedProduct
                : this.props.productList[this.props.productList.length - 1].value,
            fieldName: this.props.fieldName,
            useOneTimeOfferLabel: this.props.useOneTimeOfferLabel,
        }
    }

    onProductClick(product: Object) {
        this.setState({
            selectedProduct: product.value,
        })
    }

    render() {
        const selectedProduct = this.props.productList.find((product) => product.value === this.state.selectedProduct)

        const products = this.props.productList.map((product, i) => (
            <ProductItem
                key={product.price}
                className={`t-product-selection-item-${i + 1} t-rate-plan-${product.timePeriod} inside__plan`}
                product={product}
                active={this.state.selectedProduct === product.value}
                onClick={() => this.onProductClick(product)}
                useOneTimeOfferLabel={this.state.useOneTimeOfferLabel}
            />
        ))

        products.push(
            <input
                key={this.state.fieldName}
                type="hidden"
                name={this.state.fieldName}
                value={this.state.selectedProduct}
            />
        )

        if (windowView.isAndroidDevice() && windowView.isWebView() && selectedProduct) {
            products.push(
                <div key="total" className="u-textCenter u-halfSpaceTop u-hideAboveTablet finePrint">
                    {selectedProduct.isFreeTrial === true || selectedProduct.isFreeTrial === '1'
                        ? `After ${selectedProduct.freeTrialOfferDuration} days you will be charged`
                        : 'You will be charged the total amount of'}{' '}
                    <strong className="u-textNoWrap">{selectedProduct.totalPrice}</strong> for{' '}
                    <strong className="u-textNoWrap">{selectedProduct.timePeriod} months</strong>.
                </div>
            )
        }

        return <div className="plan__selector">{products}</div>
    }
}

export default ProductTable
